import { render, staticRenderFns } from "./ListCargaResponsavelView.vue?vue&type=template&id=38ad7352&"
import script from "./ListCargaResponsavelView.vue?vue&type=script&lang=ts&"
export * from "./ListCargaResponsavelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports